import { render, staticRenderFns } from "./ed-textarea.vue?vue&type=template&id=4d5d048f&scoped=true&"
import script from "./ed-textarea.ts?vue&type=script&lang=ts&"
export * from "./ed-textarea.ts?vue&type=script&lang=ts&"
import style0 from "./ed-textarea.scss?vue&type=style&index=0&id=4d5d048f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5d048f",
  null
  
)

export default component.exports